import React from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { timeToAutoLogoutCountDownBanner } from 'config/config';
import Styled from './AppIdleTimer.styled';
import { AppIdleTimerProps } from './AppIdleTimer.types';
import AutoLogoutBanner from './AutoLogoutBanner';


function AppIdleTimer({
    children,
    isAutoLogoutBannerVisible,
    dispatchShowAutoLogoutBanner,
    dispatchUserActivity,
}: AppIdleTimerProps) : JSX.Element {
    const handleOnIdle = () => dispatchShowAutoLogoutBanner();
    const handleOnActive = () => dispatchUserActivity();

    // XXX
    useIdleTimer({
        timeout: timeToAutoLogoutCountDownBanner,
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        crossTab: true,
    });
    return (
        <Styled.AppWrapper enableOverflowHidden={isAutoLogoutBannerVisible}>
            {isAutoLogoutBannerVisible && <AutoLogoutBanner />}
            <Styled.AppBlurOverlay activeBlur={isAutoLogoutBannerVisible}>
                {children}
            </Styled.AppBlurOverlay>
        </Styled.AppWrapper>
    );
}


export default AppIdleTimer;
